/**
 * React components for this agent's own screens, the client half of
 * `agent-dev-server/src/surfaces/index.ts`. Register each component under the `component` name
 * its contract declares, plus one for each child node name of your own that its `compose` emits.
 * A node is looked up here before the platform's components, so registering a platform name such
 * as `Column` replaces that component on every screen.
 */
import type { FC } from 'react';
import type { A2uiNodeViewProps } from '@/app/lib/a2ui/catalog.tsx';
import { LakdiEstimate } from './LakdiEstimate.tsx';
import { LakdiVisitPicker } from './LakdiVisitPicker.tsx';
import { LakdiWelcome } from './LakdiWelcome.tsx';
import { LakdiWhatsAppSummary } from './LakdiWhatsAppSummary.tsx';

export const AGENT_SURFACE_COMPONENTS: Record<string, FC<A2uiNodeViewProps>> = {
  LakdiWelcome,
  LakdiEstimate,
  LakdiVisitPicker,
  LakdiWhatsAppSummary,
};
